import { apiService, apiAuthorize } from "@base/configs";
import httpService from "@base/services/httpService";
import { IAuth } from "./auth.interface";

class AuthService {
  // resgister
  register(phone_number: string, lang: string, turnstileToken?: string) {
    const headers = { "turn-stile-token": turnstileToken };

    return httpService.post(`${apiService.auth.user.register}/${phone_number}/${lang}`, undefined, { headers });
  }

  // login
  /**
   * The server demands a captcha whenever `platform: web` is sent, so the two go out together: the
   * password step passes a turnstile token, while the OTP step logs in without either, as before.
   */
  login(username: string, password: string, turnstileToken?: string) {
    const params = { grant_type: "password", username, password };

    const headers = {
      // Set here, not left to the interceptor: it drops the client credentials once a turnstile token is present.
      Authorization: apiAuthorize,
      "Content-Type": "application/x-www-form-urlencoded",
      Accept: "application/json",
      ...(turnstileToken && { platform: "web", "turn-stile-token": turnstileToken }),
    };

    return httpService.post<IAuth>(apiService.auth.login, undefined, { headers, params });
  }

  // logout
  logout() {
    // useLogout clears the session itself either way, so the interceptor must not redirect too.
    return httpService.post(`${apiService.auth.user.logout}`, undefined, { skipAuthLogout: true });
  }
}

export default new AuthService();
